export function formatMessage(template: string, args: string[]): string {
  return template.replace(/\${(\d+)}/g, (match, indexStr) => {
    const index = parseInt(indexStr as string);
    return args.at(index) === undefined ? match : args[index];
  });
}
